





































import Vue from 'vue';
import * as utils from '@/lib/utils';
import SustainabilityReport from '@/components/Reports/SustainabilityReport.vue';
import { mapState } from 'vuex';

export default Vue.extend({
    components: {
        SustainabilityReport,
    },
    computed: {
        ...mapState('texts', ['reports']),
    },
    data() {
        return {
            dates: [] as Array<string>,
            fromDate: '',
            toDate: '',
            cards: {} as any,
            rows: [],
            cardsData: [] as Array<Record<string, any>>,
            loading: false,
        };
    },
    watch: {
        dates() {
            if (this.dates.length === 2) {
                this.fromDate = this.dates[0] as string;
                this.toDate = this.dates[1] as string;
                this.getSustainableDataForDates(this.fromDate, this.toDate);
            }
        },
        cards() {
            if (this.cards) {
                this.updateCards();
            }
        },
    },
    methods: {
        dateChanged(newDates: any) {
            this.dates = newDates;
        },
        async getSustainableDataForDates(fromDate: string, toDate: string) {
            this.loading = true;
            const { summary, ridesSustainabilityData } = await this.$hipApi.getRideSustainabilityDataFromDates(fromDate, toDate);
            // const { cardData, tableData } = await this.$hipApi.getRideSustainabilityData();
            this.cards = summary;
            this.rows = ridesSustainabilityData;
            this.loading = false;
        },
        updateCards() {
            this.cardsData = [];

            const numberOfCars = this.cards.ridesPrevented;
            const carText = numberOfCars > 1 ? 'Car rides prevented' : 'Car ride prevented';
            const formatedNumberOfCars = utils.formatNumber(numberOfCars, 0);
            const carRidePrevented = { boldText: formatedNumberOfCars, text: carText, icon: require('@/assets/icons/car.svg') };
            this.cardsData.push(carRidePrevented);

            const formatedGhgPrevented = utils.formatNumber(this.cards.ghgPrevented, 0);
            const GHGPrevented = { boldText: formatedGhgPrevented, text: 'GHG Lbs prevented', icon: require('@/assets/icons/co2.svg') };
            this.cardsData.push(GHGPrevented);

            const GHGEmissionL = { boldText: `${this.cards.emissionReduction}%`, text: 'Less GHG emissions', icon: require('@/assets/icons/graph.svg') };
            this.cardsData.push(GHGEmissionL);

            const formatedTreePlanted = utils.formatNumber(this.cards.treePlanted, 0);
            const treesPlanted = { boldText: formatedTreePlanted, text: 'Trees planted', icon: require('@/assets/icons/tree.svg') };
            this.cardsData.push(treesPlanted);
        },
        exportToCsv() {
            const csvData = this.csvData();
            const filePrefix = 'Sustainability Report';
            const fileName = `hq_shuttles_${filePrefix}_report_${this.dates[0]}_to_${this.dates[1]}.csv`;
            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
            if (navigator && navigator.msSaveBlob) {
                // IE 10+
                navigator.msSaveBlob(blob, fileName);
            } else {
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', fileName);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
        csvData() {
            let csv = 'Date, Route, Number Of Tickets, Mileage, Gallons Fuel Used, CO2 per Gallon,Other GHG, Total GHG\n';
            this.rows.forEach((row: any) => {
                csv += `${row.date},${row.routeName},${row.boardedPassengers},${row.mileage},${row.fuelUsed},${row.co2},${row.otherGhg},${row.totalGhg}\n`;
            });
            return csv;
        },
        exportToCsvDisabled() {
            return (this.rows == null) || (this.rows?.length === 0);
        },
    },
});
